/**
 * Dev-only: strip timer state from old vuex-persistedstate blobs so play/start
 * does not resurrect a zeroed running clock. Safe to call before the store boots.
 */
const LEGACY_VUEX_KEY = "vuex";

export function clearStaleTimerFromLocalStorage() {
  if (process.env.NODE_ENV === "production") return;

  try {
    const raw = localStorage.getItem(LEGACY_VUEX_KEY);
    if (!raw) return;

    const data = JSON.parse(raw);
    if (!data || typeof data !== "object") return;

    let changed = false;
    if (data.timer) {
      delete data.timer;
      changed = true;
    }
    const legacyRootKeys = [
      "timerLogsList",
      "currentTimerActive",
      "currentTimerActiveTime",
      "isTimerOn",
      "v1Session",
      "v1BaseHours",
      "timerLogHoursCache",
    ];
    legacyRootKeys.forEach((key) => {
      if (data[key] != null) {
        delete data[key];
        changed = true;
      }
    });

    if (changed) {
      localStorage.setItem(LEGACY_VUEX_KEY, JSON.stringify(data));
      console.info(
        "[nekohr dev] Cleared stale timer keys from localStorage (vuex)."
      );
    }
  } catch {
    /* ignore corrupt vuex blob */
  }
}
